import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { Stack, Tooltip, Typography } from "@mui/material";
import TooltipWrapper from "../../../../../../components/TooltipWrapper.tsx";

export interface FieldCaptionIcon {
  toolTipTitle: string;
  Icon: React.ReactNode;
}

interface Props {
  fieldCaptionIcons: FieldCaptionIcon[];
}
const compactModeThreshold = 2;

const FieldsCaptionIconSetContainer = ({ fieldCaptionIcons }: Props) => {
  const isCompactMode = fieldCaptionIcons.length > compactModeThreshold;

  if (isCompactMode) {
    return (
      <TooltipWrapper
        title={
          <Stack useFlexGap spacing={0.5}>
            {fieldCaptionIcons.map(({ Icon, toolTipTitle }) => (
              <Stack useFlexGap key={toolTipTitle} sx={{ gap: 0.5, alignItems: "center", flexDirection: "row" }}>
                {Icon}
                <Typography variant="caption" fontWeight={500}>
                  {toolTipTitle}
                </Typography>
              </Stack>
            ))}
          </Stack>
        }
      >
        <Stack
          sx={{
            flexDirection: "row",
            alignItems: "center",
            px: 0.75,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: "5px",
            gap: 0.25,
            bgcolor: "background.grey",
          }}
        >
          <TuneRoundedIcon color="primary" />
          <Typography variant="caption" color="action.active">
            {fieldCaptionIcons.length}
          </Typography>
        </Stack>
      </TooltipWrapper>
    );
  }
  return (
    <>
      {fieldCaptionIcons.map(({ Icon, toolTipTitle }) => (
        <Tooltip title={toolTipTitle} arrow key={toolTipTitle}>
          <>{Icon}</>
        </Tooltip>
      ))}
    </>
  );
};

export default FieldsCaptionIconSetContainer;
